import React from 'react';

function Hero() {
  return (
    <section className="hero" id="home" style={{
      background: `linear-gradient(180deg, transparent 0%, #240A2B 100%), url(${process.env.PUBLIC_URL}/images/bowling-hero.jpg) center/cover no-repeat`
    }}>
      <div className="container">
        <h1>Experience the Thrill of Bowling at SkyLanes Bowling Center</h1>
        <p>
          Located in the beautiful Poconos, SkyLanes Bowling Center offers family-friendly bowling,
          exciting Rock and Roll nights, delicious food, and unforgettable corporate events.
        </p>
        <a href="tel:+15704217680" className="btn">Call Us Now</a>
      </div>
    </section>
  );
}

export default Hero;
